
{
  "familyId": "STU-STAAF",
  "questions": [
    {
      "id": "STU-STAAF-001",
      "familyId": "STU-STAAF",
      "module": "Studievaardig",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "schemas",
      "subSkill": "schema_staafdiagram",
      "questionType": "bar_chart",
      "question": "Bekijk het staafdiagram. Welk fruit is het populairst?",
      "context": null,
      "options": ["Appels", "Peren", "Bananen", "Druiven"],
      "correctAnswer": 0,
      "data": {
        "data": [
          { "label": "Appels", "value": 35 },
          { "label": "Peren", "value": 20 },
          { "label": "Bananen", "value": 28 },
          { "label": "Druiven", "value": 17 }
        ],
        "correctIndex": 0,
        "xAxisLabel": "Fruit",
        "yAxisLabel": "Aantal stemmen",
        "hideValues": true
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Staafdiagram lezen",
            "content": "Zoek de hoogste staaf. Hoe hoger de staaf, hoe groter de waarde. Appels heeft de hoogste staaf (35 stemmen).",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "bar_chart_highest",
      "variantIndex": 1,
      "feedback": {
        "explanationText": "Strategie: zoek de hoogste staaf in het diagram. Stap 1: Vergelijk de hoogte van alle staven. Stap 2: Appels (35) is de hoogste, gevolgd door Bananen (28), Peren (20) en Druiven (17). Stap 3: Appels is het populairst.",
        "distractorExplanations": {
          "0": "Correct! Appels heeft de hoogste staaf met 35 stemmen.",
          "1": "Peren heeft 20 stemmen — dat is niet de hoogste staaf. Appels (35) is hoger.",
          "2": "Bananen heeft 28 stemmen — dichtbij, maar Appels (35) is nog hoger.",
          "3": "Druiven heeft 17 stemmen — de laagste staaf. Appels (35) is het populairst."
        }
      }
    },
    {
      "id": "STU-STAAF-002",
      "familyId": "STU-STAAF",
      "module": "Studievaardig",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "schemas",
      "subSkill": "schema_staafdiagram",
      "questionType": "bar_chart",
      "question": "Hoeveel meer leerlingen kiezen voetbal dan tennis? Klik op de staaf van voetbal.",
      "context": null,
      "options": ["Voetbal", "Tennis", "Zwemmen", "Hockey"],
      "correctAnswer": 0,
      "data": {
        "data": [
          { "label": "Voetbal", "value": 42 },
          { "label": "Tennis", "value": 18 },
          { "label": "Zwemmen", "value": 30 },
          { "label": "Hockey", "value": 25 }
        ],
        "correctIndex": 0,
        "xAxisLabel": "Sport",
        "yAxisLabel": "Aantal leerlingen",
        "hideValues": true
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Verschil aflezen",
            "content": "Lees de waarde van voetbal (42) en tennis (18) af. Het verschil is 42 − 18 = 24 leerlingen meer.",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "bar_chart_difference",
      "variantIndex": 2,
      "feedback": {
        "explanationText": "Strategie: lees de waarden af en bereken het verschil. Stap 1: Voetbal = 42 leerlingen. Stap 2: Tennis = 18 leerlingen. Stap 3: Verschil = 42 − 18 = 24 leerlingen meer bij voetbal.",
        "distractorExplanations": {
          "0": "Correct! Voetbal (42) heeft 24 meer leerlingen dan tennis (18).",
          "1": "Tennis is juist de sport waarmee je vergelijkt — niet het antwoord op de vraag.",
          "2": "Zwemmen (30) is niet gevraagd. De vraag gaat over voetbal vs. tennis.",
          "3": "Hockey (25) is niet gevraagd. De vraag gaat over voetbal vs. tennis."
        }
      }
    },
    {
      "id": "STU-STAAF-003",
      "familyId": "STU-STAAF",
      "module": "Studievaardig",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "schemas",
      "subSkill": "schema_staafdiagram",
      "questionType": "bar_chart",
      "question": "Welke maand had de minste regen? Klik op de juiste staaf.",
      "context": null,
      "options": ["Januari", "Februari", "Maart", "April"],
      "correctAnswer": 0,
      "data": {
        "data": [
          { "label": "Januari", "value": 45 },
          { "label": "Februari", "value": 38 },
          { "label": "Maart", "value": 52 },
          { "label": "April", "value": 60 }
        ],
        "correctIndex": 1,
        "xAxisLabel": "Maand",
        "yAxisLabel": "Regen (mm)",
        "hideValues": true
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Laagste staaf zoeken",
            "content": "Zoek de laagste staaf. Februari (38 mm) is de laagste — dat is de maand met de minste regen.",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "bar_chart_lowest",
      "variantIndex": 3,
      "feedback": {
        "explanationText": "Strategie: zoek de laagste staaf. Stap 1: Vergelijk alle staven. Stap 2: Februari (38 mm) is de laagste. Stap 3: Februari had de minste regen.",
        "distractorExplanations": {
          "0": "Januari (45 mm) is niet de laagste. Februari (38 mm) is lager.",
          "1": "Correct! Februari had met 38 mm de minste regen.",
          "2": "Maart (52 mm) is hoger dan Februari (38 mm).",
          "3": "April (60 mm) is de hoogste staaf — de meeste regen, niet de minste."
        }
      }
    },
    {
      "id": "STU-STAAF-004",
      "familyId": "STU-STAAF",
      "module": "Studievaardig",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "schemas",
      "subSkill": "schema_staafdiagram",
      "questionType": "multiple_choice",
      "question": "In een staafdiagram zie je: Groep 6 = 28 leerlingen, Groep 7 = 32 leerlingen, Groep 8 = 25 leerlingen. Hoeveel leerlingen zijn er in totaal?",
      "context": null,
      "options": ["85", "60", "90", "75"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Totaal berekenen",
            "content": "Tel alle waarden bij elkaar op: 28 + 32 + 25 = 85 leerlingen in totaal.",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "bar_chart_total",
      "variantIndex": 4,
      "feedback": {
        "explanationText": "Strategie: tel alle waarden uit het staafdiagram bij elkaar op. Stap 1: Groep 6 = 28. Stap 2: Groep 7 = 32. Stap 3: Groep 8 = 25. Stap 4: 28 + 32 + 25 = 85.",
        "distractorExplanations": {
          "0": "Correct! 28 + 32 + 25 = 85 leerlingen in totaal.",
          "1": "60 is te laag. Je hebt waarschijnlijk maar twee groepen opgeteld: 28 + 32 = 60. Vergeet groep 8 (25) niet.",
          "2": "90 is te hoog. Controleer: 28 + 32 + 25 = 85, niet 90.",
          "3": "75 klopt niet. Controleer je berekening: 28 + 32 + 25 = 85."
        }
      }
    },
    {
      "id": "STU-STAAF-005",
      "familyId": "STU-STAAF",
      "module": "Studievaardig",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "schemas",
      "subSkill": "schema_staafdiagram",
      "questionType": "bar_chart",
      "question": "Welk huisdier komt het vaakst voor? Klik op de juiste staaf.",
      "context": null,
      "options": ["Hond", "Kat", "Konijn", "Vis"],
      "correctAnswer": 0,
      "data": {
        "data": [
          { "label": "Hond", "value": 15 },
          { "label": "Kat", "value": 22 },
          { "label": "Konijn", "value": 8 },
          { "label": "Vis", "value": 12 }
        ],
        "correctIndex": 1,
        "xAxisLabel": "Huisdier",
        "yAxisLabel": "Aantal",
        "hideValues": true
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Hoogste staaf",
            "content": "De hoogste staaf is Kat (22). Dat huisdier komt het vaakst voor.",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "bar_chart_most_common",
      "variantIndex": 5,
      "feedback": {
        "explanationText": "Strategie: zoek de hoogste staaf. Kat (22) > Hond (15) > Vis (12) > Konijn (8). Kat komt het vaakst voor.",
        "distractorExplanations": {
          "0": "Hond (15) is niet de hoogste. Kat (22) is hoger.",
          "1": "Correct! Kat heeft de hoogste staaf met 22.",
          "2": "Konijn (8) is de laagste staaf.",
          "3": "Vis (12) is lager dan Kat (22) en Hond (15)."
        }
      }
    }
  ]
}
